<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="8" @click="toNewRouter('ladder-over-view')" v-if="permissionCodes.indexOf('009009000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="1" @click="toNewRouter('ladder-device')" v-if="permissionCodes.indexOf('009001000') !== -1">
        <i class="el-icon-damai-shebei"></i>
        <span slot="title">设备管理</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('elevator')" v-if="permissionCodes.indexOf('009002000') !== -1">
        <i class="el-icon-damai-dianti"></i>
        <span slot="title">电梯管理</span>
      </el-menu-item>
      <!--<el-menu-item index="3" @click="toNewRouter('elevator-authorize')" v-if="permissionCodes.indexOf('009003000') !== -1">-->
        <!--<i class="el-icon-damai-anquan"></i>-->
        <!--<span slot="title">授权管理</span>-->
      <!--</el-menu-item>-->
      <el-submenu index="3" v-if="permissionCodes.indexOf('009003000') !== -1 || permissionCodes.indexOf('009004000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-anquan"></i>
          <span slot="title">授权管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="3-1" @click="toNewRouter('elevator-authorize')" v-if="permissionCodes.indexOf('009003000') !== -1">授权乘梯</el-menu-item>
          <el-menu-item index="3-2" @click="toNewRouter('elevator-black-list')" v-if="permissionCodes.indexOf('009004000') !== -1">限制乘梯</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="6" @click="toNewRouter('ladder-plant-manage')" v-if="permissionCodes.indexOf('009006000') !== -1">
        <i class="el-icon-damai-config"></i>
        <span slot="title">梯控计划</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('identification-record')" v-if="permissionCodes.indexOf('009005000') !== -1">
        <i class="el-icon-damai-jinchukoudengji"></i>
        <span slot="title">识别记录</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('ladder-device-status-log')" v-if="permissionCodes.indexOf('009007000') !== -1">
        <i class="el-icon-damai-zhuangtairizhi"></i>
        <span slot="title">设备状态日志</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('ladder-control-log')" v-if="permissionCodes.indexOf('009008000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ["ladder-device", "ladder-device-add", "ladder-device-modify"],
  2: ["elevator", "elevator-add", "elevator-modify"],
  // '3': ['elevator-authorize', 'authorize-add', 'authorize-modify'],
  "3-1": ["elevator-authorize", "authorize-add", "authorize-modify"],
  "3-2": ["elevator-black-list", "elevator-black-list-add"],
  4: "ladder-control-log",
  5: "identification-record",
  6: ["ladder-plant-manage", "ladder-plant-add", "ladder-plant-modify"],
  7: "ladder-device-status-log",
  8: "ladder-over-view",
});

export default {
  name: "ladder-control-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/LadderControlNav.vue